import React from 'react';
import styled from 'styled-components';

import cancleImage from '@/assets/common/cancle.png';

type Props = {
  title: string;
  cancelAmount: string;
  contentElement?: React.ReactNode;
  onClickBtn: () => void;
  onClickSubBtn: () => void;
  btnTitle: string;
  btnDisabled?: boolean;
  subBtnTitle: string;
  onClose?: () => void;
};

function PaymentCancelInfoModal({
  title,
  cancelAmount,
  onClickBtn,
  onClickSubBtn,
  btnTitle,
  btnDisabled = false,
  subBtnTitle,
  onClose,
  contentElement,
}: Props) {
  return (
    <Wrapper>
      <Container>
        <Header>
          <Title>{title}</Title>

          {onClose && <Cancel src={cancleImage} onClick={onClose} />}
        </Header>
        <Desc>해외 간편 결제 취소금액</Desc>
        <CancelAmount>{cancelAmount}원</CancelAmount>
        {contentElement}
        <ButtonWrapper>
          <Button color='#3A3B3E' bgColor='#E5E6E8' onClick={onClickSubBtn}>
            {subBtnTitle}
          </Button>
          <Button
            color='#FFFFFF'
            bgColor='#246CF6'
            onClick={onClickBtn}
            disabled={btnDisabled}
          >
            {btnTitle}
          </Button>
        </ButtonWrapper>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 600;
  background-color: rgba(33, 33, 33, 0.1);
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 672px;
  padding: 32px;
  position: relative;
  border-radius: 8px;
  background-color: ${(props) => props.theme.pointColors.white};
  filter: ${(props) => props.theme.boxShadow};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Title = styled.h1`
  color: var(--Mono-80, #3a3b3e);
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const Desc = styled.p`
  display: flex;
  color: var(--Mono-80, #3a3b3e);

  /* WebHead/21_BD */
  font-family: Pretendard;
  font-size: 21px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 31.5px */
  letter-spacing: -0.42px;
  margin: 16px 0 0;
`;
const Button = styled.button<{
  bgColor: string;
  color: string;
  btnDisabled?: boolean;
}>`
  flex: 1;
  border-radius: 8px;
  padding: 14px;
  font-size: ${(props) => props.theme.fontSize.small};
  color: ${(props) => props.color};
  background-color: ${(props) => (props.disabled ? '#D3E2FD' : props.bgColor)};
  line-height: 150%;
  font-weight: 600;
`;
const Cancel = styled.img`
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 18px;
  margin-top: 16px;
`;

const CancelAmount = styled.div`
  display: flex;

  color: var(--Blue-100, #246cf6);
  font-family: Pretendard;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 63px */
  letter-spacing: -0.84px;

  border-bottom: 1px solid var(--Mono-20, #cbccce);
`;

export default PaymentCancelInfoModal;
